export default "__VITE_ASSET__v1VEviTF__"